<template>
    <div class="mobile" type="false">
        <headers_m></headers_m>
        <div class="main">
            <div class="personal_en">
                <div>
                    <span>{{$t('signUp').name.title}}</span>：
                    <span>{{name}}</span>
                </div>
                <div>
                    <span>{{$t('signUp').email.title}}</span>：
                    <span>{{email}}</span>
                </div>
                <div>
                    <span>{{$t('signUp').country.title}}</span>：
                    <span>{{country}}</span>
                </div>
                <div>
                    <span>{{$t('signUp').region.title}}</span>：
                    <span>{{region}}</span>
                </div>
                <div>
                    <span>{{$t('signUp').company.title}}</span>：
                    <span>{{company}}</span>
                </div>
                <div>
                    <span>{{$t('signUp').job_title.title}}</span>：
                    <span>{{job_title}}</span>
                </div>

                <div>
                    <span>{{$t('signUp').meeting_type.title}}</span>：
                    <span v-if="meeting_type==1">{{$t('signUp').meeting_type.select['checkB'].value}}</span>
                    <span v-if="meeting_type==2">{{$t('signUp').meeting_type.select['checkA'].value}}</span>
                </div>
                <div v-if="meeting_type==1">
                    <span>{{$t('signUp').is_dine.title}}</span>：
                    <span v-if="is_dine==2">{{$t('signUp').is_dine.select['checkB'].value}}</span>
                    <span v-if="is_dine==1">{{$t('signUp').is_dine.select['checkA'].value}}</span>
                </div>
                <div v-if="meeting_type==1">
                    <span>{{$t('signUp').cellphone.title}}</span>：
                    <span>{{cellphone}}</span>
                </div>
                <p class="login_btn_m" v-if="audit_status==1">{{$t('personal').tips3}}</p>
                <p class="login_btn_m" v-if="audit_status==2">{{$t('personal').tips1}}</p>
                <p class="login_btn_m" v-if="audit_status==3">{{$t('personal').tips2}}</p>
            </div>
        </div>
        <div class="footer_mobile">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
    </div>
</template>

<script>
    import headers_m from "../components/headers_m.vue"
    export default {
        components: {
            headers_m
        },
        name: 'personal',
        data() {
            return {
                lang: "",
                name: "",
                email: "",
                country: "",
                region: "",
                company: "",
                job_title: "",
                meeting_type: "",
                is_dine: "",
                cellphone: "",
                audit_status: 1
            }
        },
        created() {
            let lang = localStorage.getItem("lang");
            this.$i18n.locale = this.lang = lang;
            let that = this,
                data = new FormData();
            that.rq.post("/user/userinfo").then(res => {
                console.log(res.data)
                if (res.code == '1') {
                    that.name = res.data.userinfo.name
                    that.email = res.data.userinfo.email
                    that.country = res.data.userinfo.nation
                    that.region = res.data.userinfo.region
                    that.company = res.data.userinfo.mechanism
                    that.job_title = res.data.userinfo.job_title
                    that.meeting_type = res.data.userinfo.meeting_type
                    that.is_dine = res.data.userinfo.is_dine
                    that.cellphone = res.data.userinfo.cellphone
                    that.audit_status = res.data.userinfo.audit_status
                    localStorage.setItem('sign',res.data.userinfo.audit_status)
                }
            })

        },
        mounted() {

        },
        methods: {}
    }
</script>
<style scoped>
    .personal,
    .personal_en {
        width: 633px;
        padding: 50px 30px 0;
        background: linear-gradient(-52deg, #2D1300 0%, #000000 50%, #2D1300 100%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
    }
    
    .personal>div,
    .personal_en>div {
        font-size: 28px;
        line-height: 35px;
        padding-bottom: 30px;
        margin: 0 auto;
        display: flex;
        align-items: flex-start;
        width: 100%;
    }
    
    .personal>div>span:first-child {
        /* width: 100px; */
        text-align: justify;
        display: inline-block;
        text-justify: distribute;
        text-align-last: justify;
        flex: 1;
    }
    
    .personal_en>div>span:first-child {
        display: inline-block;
        /* width: 140px; */
        text-align: right;
        padding-right: 5px;
        flex: 1;
    }
    
    .personal>div>span:last-child,
    .personal_en>div>span:last-child {
        flex: 1.4;
    }
</style>


// WEBPACK FOOTER //
// src/views/personal.vue